<template>
  <c-box>
    <c-heading
      as="h3"
      v-if="basicInfoHeader"
      :fontSize="{ base: '2xl', sm: '4xl' }"
      fontWeight="400"
      :mb="{ base: 'md', sm: '3xl' }"
    >
      {{ basicInfoHeader }}
    </c-heading>
    <c-text
      v-for="(text, index) in basicInfoSystemLevelDescription"
      :key="`sld-${index}`"
      :fontSize="{ base: 'sm', sm: 'md' }"
      :mb="{ base: 'md', sm: 'lg' }"
    >
      {{ text }}
    </c-text>
    <c-heading
      as="h4"
      v-if="basicInfoFeatureSummaryHeader"
      :fontSize="{ base: 'md', sm: '2xl' }"
      :fontWeight="{ base: 700, sm: 400 }"
      :mb="{ base: 'md', sm: 'lg' }"
    >
      {{ basicInfoFeatureSummaryHeader }}
    </c-heading>
    <c-text
      v-for="(text, index) in basicInfoFeatureSummary"
      :key="`fs-${index}`"
      :fontSize="{ base: 'sm', sm: 'md' }"
      :mb="{ base: 'md', sm: 'lg' }"
    >
      {{ text }}
    </c-text>
  </c-box>
</template>
<script lang="ts">
import { CBox, CHeading, CText } from "@chakra-ui/vue";

export default {
  name: "ProductDataBasicInfo1",
  components: {
    CBox,
    CText,
    CHeading,
  },
  props: {
    basicInfoFeatureSummary: {},
    basicInfoFeatureSummaryHeader: {},
    basicInfoHeader: {},
    basicInfoSystemLevelDescription: {},
  },
};
</script>
